import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(popupOpenSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(popupOpenSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseAllSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseAllSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseWithAnswerSagaWorker),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(popupCloseWithAnswerSagaWatcher),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(popupsSaga);

import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { ConstantsUtil } from '@utils';
import { INIT_CLOSE_ALL_POPUPS, INIT_CLOSE_POPUP, INIT_POPUP_CLOSING_WITH_ANSWER, POPUP_INIT } from './popups.action-types';
import { actions } from './popups.actions';

/**
 * Open popup saga worker.
 *
 * @author Ihar Kazlouski
 * @function popupOpenSagaWorker
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<PutEffect>} action data.
 */
function popupOpenSagaWorker(action) {
  return _regeneratorRuntime.wrap(function popupOpenSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.setPopup({
            popupId: action.payload.popupId,
            isOpen: action.payload.isOpen,
            data: action.payload.data
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Set new popup to saga watcher.
 *
 * @author Ihar Kazlouski
 * @function popupOpenSagaWatcher
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function popupOpenSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupOpenSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(POPUP_INIT, popupOpenSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Close popup saga worker.
 *
 * @author Ihar Kazlouski
 * @function popupCloseSagaWorker
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<PutEffect>} action data.
 */


function popupCloseSagaWorker(action) {
  return _regeneratorRuntime.wrap(function popupCloseSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.popupClose({
            popupId: action.payload.popupId
          }));

        case 2:
          _context3.next = 4;
          return put({
            type: "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              popupId: action.payload.popupId
            }
          });

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Close popup.
 *
 * @author Ihar Kazlouski
 * @function popupCloseSagaWatcher
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function popupCloseSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupCloseSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(INIT_CLOSE_POPUP, popupCloseSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Close all popups saga worker.
 *
 * @author Ihar Kazlouski
 * @function popupCloseAllSagaWorker
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<PutEffect>} action data.
 */


function popupCloseAllSagaWorker() {
  return _regeneratorRuntime.wrap(function popupCloseAllSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.popupCloseAll());

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Close popup.
 *
 * @author Ihar Kazlouski
 * @function popupCloseSagaWatcher
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function popupCloseAllSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupCloseAllSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(INIT_CLOSE_ALL_POPUPS, popupCloseAllSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Close popup with answer saga worker.
 *
 * @author Ihar Kazlouski
 * @function popupCloseWithAnswerSagaWorker
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<PutEffect>} action data.
 */


function popupCloseWithAnswerSagaWorker(action) {
  return _regeneratorRuntime.wrap(function popupCloseWithAnswerSagaWorker$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return put(actions.closeWithAnswer({
            popupId: action.payload.popupId,
            accepted: action.payload.accepted,
            rejected: action.payload.rejected
          }));

        case 2:
          if (!action.payload.accepted) {
            _context7.next = 7;
            break;
          }

          _context7.next = 5;
          return put({
            type: "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              popupId: action.payload.popupId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 5:
          _context7.next = 9;
          break;

        case 7:
          _context7.next = 9;
          return put({
            type: "".concat(POPUP_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            error: {
              popupId: action.payload.popupId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 9:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Close popup with answer.
 *
 * @author Ihar Kazlouski
 * @function popupCloseWithAnswerSagaWatcher
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function popupCloseWithAnswerSagaWatcher() {
  return _regeneratorRuntime.wrap(function popupCloseWithAnswerSagaWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return all([takeLatest(INIT_POPUP_CLOSING_WITH_ANSWER, popupCloseWithAnswerSagaWorker)]);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
/**
 * Popups saga.
 *
 * @author Ihar Kazlouski
 * @function popupsSaga
 * @category Sagas
 * @subcategory Popups
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function popupsSaga() {
  return _regeneratorRuntime.wrap(function popupsSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return all([fork(popupOpenSagaWatcher), fork(popupCloseSagaWatcher), fork(popupCloseWithAnswerSagaWatcher), fork(popupCloseAllSagaWatcher)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}